import { GetStaticProps } from "next";

import { PLASMIC } from "@abnormal/plasmic-init";
import TeamLayout from "@layouts/TeamLayout";
import { returnStaticProps } from "@lib/returnStaticProps";
import craft from "@pages/api/craft";
import QueryTeamIndex from "@queries/team/QueryTeamIndex.graphql";

export const getStaticProps: GetStaticProps = async () => {
	// Hard code the page's uri
  const uri = "/about/team";
  
  const plasmicData = await PLASMIC.maybeFetchComponentData([
    "Footer"
  ], {
    // deferChunks: true,
  });
  if (!plasmicData) {
    throw new Error("No Plasmic design found");
  }

	// Fetch the page's data
	const response = await craft(QueryTeamIndex);

	const {
		pageEntry,
		profiles,
		profileTypes,
		primaryNavigation,
		primaryCallToActions,
		persistentNav,
	} = response;

	// Return props if entry exists, otherwise check Retour for redirects or 404
	const returnResponse = await returnStaticProps(
		{
			navigation: {
				primaryNavigation,
				primaryCallToActions,
			},
			pageEntry,
			persistentNav,
			profiles,
      profileTypes,
      plasmicData
		},
		!pageEntry,
		uri
	);

	return returnResponse;
};

interface IProps {
	pageEntry: any;
	profiles: any[];
	profileTypes: any[];
}

const Page = ({ pageEntry, profiles, profileTypes }: IProps): JSX.Element => {
	return <></>;
};

Page.Layout = TeamLayout;

export default Page;
